export default __webpack_public_path__ + "static/media/aixm-banner.0f99d37c.jpg";